// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */

/**
 * NOTE:
 *
 * ED-16073:
 * This was manually updated since the original `@atlaskit/i18n-tools` has been deprecated
 */
export { default as zh } from './zh';
export { default as zh_TW } from './zh_TW';
export { default as cs } from './cs';
export { default as da } from './da';
export { default as en } from './en';
export { default as en_GB } from './en_GB';
export { default as en_ZZ } from './en_ZZ';
export { default as nl } from './nl';
export { default as et } from './et';
export { default as fi } from './fi';
export { default as fr } from './fr';
export { default as de } from './de';
export { default as hu } from './hu';
export { default as it } from './it';
export { default as ja } from './ja';
export { default as ko } from './ko';
export { default as nb } from './nb';
export { default as pl } from './pl';
export { default as pt_BR } from './pt_BR';
export { default as pt_PT } from './pt_PT';
export { default as ru } from './ru';
export { default as sk } from './sk';
export { default as es } from './es';
export { default as sv } from './sv';
export { default as th } from './th';
export { default as tr } from './tr';
export { default as uk } from './uk';
export { default as vi } from './vi';
export { default as is } from './is';
export { default as ro } from './ro';